import { api } from '../lib/api'
import type { BiweeklyReport, ReportDetail, ReportListItem } from '../lib/types'

export interface ReportFilters {
  clientId?: string
  status?: 'draft' | 'published'
  read?: 'unread' | 'read' | 'all' // padrão do front: 'unread'
  week?: string // YYYY-MM-DD — filtra a semana Seg–Dom desta data (por weekEnd)
}

function toQuery(filters: ReportFilters): string {
  const params = new URLSearchParams()
  if (filters.clientId) params.set('clientId', filters.clientId)
  if (filters.status) params.set('status', filters.status)
  if (filters.read && filters.read !== 'all') params.set('read', filters.read)
  if (filters.week) params.set('week', filters.week)
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}

export interface ErrorReport {
  id: string
  client: { id: string; name: string }
  weekStart: string
  weekEnd: string
  generatedAt: string
  status: 'error' | 'processing' // 'processing' = travado há +30min
  errorMessage: string | null
}

export const reportsApi = {
  list: (filters: ReportFilters = {}) =>
    api.get<{ reports: ReportListItem[] }>(`/reports${toQuery(filters)}`),
  errors: () => api.get<{ reports: ErrorReport[] }>('/reports/errors'),
  get: (id: string) => api.get<ReportDetail>(`/reports/${id}`),
  markRead: (id: string) => api.post<{ ok: true; readAt: string }>(`/reports/${id}/read`, {}),
  regenerateSummary: (id: string) =>
    api.post<{ learningSummary: string | null }>(`/reports/${id}/summary`, {}),
  clearSummary: (id: string) => api.del<{ ok: true }>(`/reports/${id}/summary`),
  publish: (id: string) =>
    api.put<{ report: { id: string; status: string; publishedAt: string } }>(
      `/reports/${id}/publish`,
      {}
    ),
  biweekly: (id: string) => api.get<BiweeklyReport>(`/reports/${id}/biweekly`),
  remove: (id: string) => api.del<{ ok: true }>(`/reports/${id}`),
}

export const analyzeApi = {
  run: (clientId: string, body: { weekStart?: string; weekEnd?: string } = {}) =>
    api.post<{
      reportId: string
      status: string
      optimizationsCount: number
      investigationsCount: number
    }>(`/analyze/${clientId}`, body),
  preview: (clientId: string) => api.get<{ prompt: string }>(`/analyze/${clientId}/preview`),
}
